import Api from './Api';

class _StatisticsApi extends Api {
    loadStatistics(): Promise<any> {
        return this.getHttpClient().get(`statistics/dashboard`);
    }

    loadLastMonthProjectList(): Promise<any> {
        return this.getHttpClient().get(`statistics/order/last-month`);
    }

    loadCustomerStatistics(): Promise<any> {
        return this.getHttpClient().post(`statistics/dashboard/customer`);
    }
}

export const StatisticsApi = new _StatisticsApi();
